function animateWideluxDot() {
  const heading = document.querySelector('h1');
  if (!heading) return;

  if (
    heading.textContent.includes('WIDELUX•X') &&
    !heading.querySelector('.wideluxx-dot')
  ) {
    heading.innerHTML = heading.innerHTML.replace(
      '•',
      '<span class="wideluxx-dot">•</span>'
    );
  }

  const dot = heading.querySelector('.wideluxx-dot');
  if (!dot || dot.classList.contains('is-red')) return;

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      dot.classList.add('is-red');
    });
  });
}

document.addEventListener('DOMContentLoaded', animateWideluxDot);

const observer = new MutationObserver(() => {
  animateWideluxDot();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});